var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"warning","size":"sm"},on:{"click":function($event){_vm.moderatePublication(_vm.item)}}},[(_vm.itemEnabled(_vm.item))?[_c('i',{staticClass:"ti ti-close"})]:[_c('i',{staticClass:"ti ti-check"})]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3be878a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModerateButton.vue
// module id = 936
// module chunks = 1